class ImageApproval {
    init(container) {
        jQuery(container).children().unbind();

        jQuery("#needs_attention", container).on("mouseleave", ".unchecked", function () {
            let t = jQuery(this);
            $.post("/administration/images/checked/" + t.data("id"));
            t.addClass("checked");
            t.removeClass("unchecked");
        });

        jQuery(".row", container).on("click", ".item", function () {
            let t = jQuery(this);
            if (t.hasClass("disabled")) {
                $.post("/administration/images/enable/" + t.data("id"));
                t.removeClass("disabled");
            } else {
                $.post("/administration/images/disable/" + t.data("id"));
                t.addClass("disabled");
            }
        });
    }
}